"use strict";

exports.__esModule = true;
exports.processRequestQueue = exports.queueRequest = void 0;

var _cloneSvg = _interopRequireDefault(require("./clone-svg.js"));

var _svgCache = _interopRequireDefault(require("./svg-cache.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestQueue = {};

var queueRequest = function queueRequest(url, callback) {
  requestQueue[url] = requestQueue[url] || [];
  requestQueue[url].push(callback);
};

exports.queueRequest = queueRequest;

var processRequestQueue = function processRequestQueue(url) {
  for (var i = 0, len = requestQueue[url].length; i < len; i++) {
    // Make these calls async so we avoid blocking the page/renderer.
    ;

    (function (index) {
      setTimeout(function () {
        if (Array.isArray(requestQueue[url])) {
          var cb = requestQueue[url][index];

          if (_svgCache.default[url] instanceof SVGSVGElement) {
            cb(null, (0, _cloneSvg.default)(_svgCache.default[url]));
          } else if (_svgCache.default[url] instanceof Error) {
            cb(_svgCache.default[url]);
          } else {
            throw new Error('Cannot process requestQueue for ' + url);
          }

          if (index === requestQueue[url].length - 1) {
            delete requestQueue[url];
          }
        }
      }, 0);
    })(i);
  }
};

exports.processRequestQueue = processRequestQueue;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@tanem/svg-injector/lib/request-queue.js
 ** module id = 1050
 ** module chunks = 0
 **/